export const KeyCodes = {
  ENTER: 13,
  ESCAPE: 27,
};
